<template>
<div>

<navbar></navbar>

  <div class="grid row h100 main">

    <div class="grid h100 nav2">

    <div class="spacer xs"></div>

    <template>
        <el-select v-model="value" placeholder="Jahr auswählen">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>

      <div class="spacer xs"></div>

      <template>
        <el-select v-model="benchlang" placeholder="Sprache auswählen">
          <el-option
            v-for="item in benchlangs"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>

      <div class="spacer xs"></div>

    <p v-if="value"><strong><a class="btn btn-block btn-green" href="#" v-on:click="getBenchAll()">Alle Strukturen</a></strong></p>
    <p v-if="!value"><strong>Bitte Jahr auswählen</strong></p>
    <div class="spacer xl"></div>
    <div class="spacer xl"></div>
    <a v-if="value" v-on:click="saveContent" class="btn btn-block btn-dark">speichern</a>
    <div class="spacer sm"></div>

    <!-- <a v-if="value" :href="/print/{{value}}" class="btn btn-block btn-dark">drucken</a> -->
    <router-link v-if="value && benchlang" :to="'/print/' + benchlang + '/' + value" target="_blank" class="btn btn-block btn-dark">Drucken</router-link>
    <router-link v-if="value && benchlang" :to="'//bench.node.systems:44534/export/pdf/' + benchlang + '/' + value + '/' + tokwt" target="_blank" class="btn btn-block btn-dark">PDF</router-link>
    <!-- <router-link v-if="value && benchlang" :to="'//bench.node.systems:44534/export/word/' + benchlang + '/' + value + '/' + tokwt" target="_blank" class="btn btn-block btn-dark">Word</router-link> -->
    <!-- <router-link v-if="value && benchlang" :to="'//bench.node.systems:44534/export/word/' + benchlang + '/' + value + '/' + tokwt" target="_blank" class="btn btn-block btn-dark">Word</router-link> -->
    <button type="button" class="btn btn-block btn-dark" @click="saveWord()">Word Export</button>
    <button type="button" class="btn btn-block btn-dark" @click="savetocsv()">Csv Export</button>
    <!-- <router-link :to="{ path: 'print', params: { year: value }}">User</router-link> -->
    <!-- <p><a href="#" v-on:click="getBench2('klein')">Kleine Strukturen</a></p>
    <p><a href="#" v-on:click="getBench2('mittel')">Mittlere Strukturen</a></p>
    <p><a href="#" v-on:click="getBench2('gross')">Grosse Strukturen</a></p> -->

<!--       <p v-for="house in houses">
        <a href="#" v-on:click="getBench(house._id)">{{house.struktur}}</a>
      </p> -->


    </div>

    <div class="grid h100  innercontent" v-if="!cont"><h3>Jahr auswählen bitte</h3></div>

    <div class="grid h100  innercontent" v-if="cont">

      <!-- <p>{{quests}}</p>  -->

      <!-- {{ratios}} -->

    <circle4 v-if="loading"></circle4>

    <div class="spacer sm"></div>
      <!-- <p v-for="ratioquest in ratioquests">{{ratioquest.cat}}</p> -->

      <!-- <a v-on:click="saveContent" style="position: absolute top: 12px right: 12px"><span class="fa fa-flash"></span></a> -->

      <vue-editor v-if="benchlang === 'de'" id="editor1" v-model="content[1]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor1" v-model="contentit[1]"></vue-editor>

      <h2 v-if="benchlang === 'de'">1. FÜHRUNG</h2>
      <h2 v-if="benchlang === 'it'">1. DIRIGENZA</h2>

      <!-- <h5 v-if="benchlang === 'de'">Verhältnis Brutto- / Nettostunden Mitarbeiter in Prozent (Anteil Ist-Stunden auf Sollstunden der Mitarbeiter)</h5> -->
      <h5 v-if="benchlang === 'de'">{{quests[1].de}}</h5>
      <h5 v-if="benchlang === 'it'">Ore prestate dai collaboratori: lordo/netto in percentuale (media percentuale delle ore effettive rispetto alle ore teoriche)</h5>
      <!-- <h5 v-if="benchlang === 'it'">{{quests[1].it}}</h5> -->
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[1].total / klein[1].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[1].total / mittel[1].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[1].total / gross[1].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[1].total / klein[1].arr.length)+(mittel[1].total / mittel[1].arr.length)+(gross[1].total / gross[1].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Verhältnis Brutto- / Nettostunden Mitarbeiter (Mittelwerte)', padding: 40 }}"></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[1].total / klein[1].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[1].total / mittel[1].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[1].total / gross[1].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[1].total / klein[1].arr.length)+(mittel[1].total / mittel[1].arr.length)+(gross[1].total / gross[1].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Ore prestate dai collaboratori: lordo/netto (media)', padding: 40 }}" ></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor2" v-model="content[2]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor2" v-model="contentit[2]"></vue-editor>

<!--       <p>{{klein[5]}}</p>
      <p>{{mittel[5]}} </p>
      <p>{{gross[5]}}</p>
      <p>{{overall[5]}}</p> -->

      <h2 v-if="benchlang === 'de'">2. POLITIK UND STRATEGIE</h2>
      <h2 v-if="benchlang === 'it'">2. POLITICA E STRATEGIA</h2>

      <h5 v-if="benchlang === 'de'">Auslastung in den RQA-Heimen (Mittelwerte in Prozent)</h5>
      <!-- <h5 v-if="benchlang === 'de'">{{quests[2].de}}</h5> -->
      <h5 v-if="benchlang === 'it'">Copertura dei posti letto nelle residenze RQA (media in percentuale)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [quests[2].de, quests[3].de, quests[4].de, quests[5].de],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[2].total / klein[2].arr.length, klein[3].total / klein[3].arr.length, klein[4].total / klein[4].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[2].total / mittel[2].arr.length, mittel[3].total / mittel[3].arr.length, mittel[4].total / mittel[4].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[2].total / gross[2].arr.length, gross[3].total / gross[3].arr.length, gross[4].total / gross[4].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[2].total / klein[2].arr.length)+(mittel[2].total / mittel[2].arr.length)+(gross[2].total / gross[2].arr.length))/3, ((klein[3].total / klein[3].arr.length)+(mittel[3].total / mittel[3].arr.length)+(gross[3].total / gross[3].arr.length))/3, ((klein[4].total / klein[4].arr.length)+(mittel[4].total / mittel[4].arr.length)+(gross[4].total / gross[4].arr.length))/3, overall[5].total / overall[5].arr.length]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, max: 120 } }] }, title: { display: false, text: 'Auslastung in den RQA-Heimen (Mittelwerte)', padding: 40
        }}" ></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [['Copertura dei posti letto in %','Ricovero permanente'], ['Copertura dei posti letto in %', 'Ricovero temporaneo'], ['Copertura dell’assistenza diurna in %'], ['Copertura del centro assistenza diurna in %']],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[2].total / klein[2].arr.length, klein[3].total / klein[3].arr.length, klein[4].total / klein[4].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[2].total / mittel[2].arr.length, mittel[3].total / mittel[3].arr.length, mittel[4].total / mittel[4].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[2].total / gross[2].arr.length, gross[3].total / gross[3].arr.length, gross[4].total / gross[4].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[2].total / klein[2].arr.length)+(mittel[2].total / mittel[2].arr.length)+(gross[2].total / gross[2].arr.length))/3, ((klein[3].total / klein[3].arr.length)+(mittel[3].total / mittel[3].arr.length)+(gross[3].total / gross[3].arr.length))/3, ((klein[4].total / klein[4].arr.length)+(mittel[4].total / mittel[4].arr.length)+(gross[4].total / gross[4].arr.length))/3, overall[5].total / overall[5].arr.length]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return '' } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, max: 120 } }] }, title: { display: false, text: 'Auslastung in den RQA-Heimen (Mittelwerte)', padding: 40
        }}" ></stats>

        <vue-editor v-if="benchlang === 'de'" id="editor3" v-model="content[3]"></vue-editor>
        <vue-editor v-if="benchlang === 'it'" id="editor3" v-model="contentit[3]"></vue-editor>

        <h2 v-if="benchlang === 'de'">3. MITARBEITER</h2>
        <h2 v-if="benchlang === 'it'">3. COLLABORATORI</h2>

        <h5 v-if="benchlang === 'de'">Mitarbeiter Vollzeit/Teilzeit in %. Stichtag: 31.12.</h5>
        <!-- <h5 v-if="benchlang === 'de'">{{quests[6].de}}</h5> -->
        <h5 v-if="benchlang === 'it'">Collaboratori con rapporto di lavoro a tempo pieno/a tempo parziale (quota percentuale e numero)</h5>
        <!-- <h5 v-if="benchlang === 'it'">{{quests[6].it}}</h5> -->

        <!-- <div><span class="legend green">Vollzeit</span><span class="legend yellow">Teilzeit</span></div> -->

      <div class="grid" style="grid-template-columns: 1fr 1fr 1fr">
      <div class=""><pie v-if="benchlang === 'de'" :chart-data="{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)],
          cal: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)],
          cal: [(klein[6].totval / klein[6].val.length), (klein[7].totval / klein[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return (context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex]).toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Kleine Strukturen'}}" ></pie></div>

      <div class=""><pie v-if="benchlang === 'de'" :chart-data="{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)],
          cal: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)],
          cal: [(mittel[6].totval / mittel[6].val.length), (mittel[7].totval / mittel[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return (context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex]).toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Mittlere Strukturen'}}" ></pie></div>

        <div class=""><pie v-if="benchlang === 'de'" :chart-data="{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)],
          cal: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)],
          cal: [(gross[6].totval / gross[6].val.length), (gross[7].totval / gross[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return (context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex]).toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Grosse Strukturen'}}" ></pie></div>



       <div class=""><pie v-if="benchlang === 'it'" :chart-data="{
      labels: [
      'Tempo parziale', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)],
          cal: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)],
          cal: [(klein[6].totval / klein[6].val.length), (klein[7].totval / klein[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return (context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex]).toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture piccole'}}" ></pie></div>

      <div class=""><pie v-if="benchlang === 'it'" :chart-data="{
      labels: [
      'Tempo parziale', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)],
          cal: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)],
          cal: [(mittel[6].totval / mittel[6].val.length), (mittel[7].totval / mittel[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return (context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex]).toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture medie'}}" ></pie></div>

        <div class=""><pie v-if="benchlang === 'it'" :chart-data="{
      labels: [
      'Tempo parziale', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)],
          cal: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)],
          cal: [(gross[6].totval / gross[6].val.length), (gross[7].totval / gross[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex] + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture grandi'}}" ></pie></div>

        </div>

         <!-- <div class="w12">
          <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[6].total / klein[6].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[6].total / mittel[6].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[6].total / gross[6].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[6].total / klein[6].arr.length)+(mittel[6].total / mittel[6].arr.length)+(gross[6].total / gross[6].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }}"></stats>
        </div> -->


        <!-- <div class="grid" style="grid-template-columns: 1fr 2fr">
      <div class="w4"><pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['Mitarbeit in Teilzeitarbeitsverhältnis (Anteil in % und Anzahl) - Stichtag: 31.12.', 'Mitarbeiter in Vollzeitarbeitsverhältnis (Anteil in % und Anzahl) - Stichtag: 31.12.'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: false, position: 'top'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }}}, title: { display: true, text: 'Mitarbeit in Teilzeit- / Vollzeitarbeitsverhältnis (Mittelwerte)'
        }}" ></pie></div>

        <div class="w8">
          <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[6].total / klein[6].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[6].total / mittel[6].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[6].total / gross[6].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[6].total / klein[6].arr.length)+(mittel[6].total / mittel[6].arr.length)+(gross[6].total / gross[6].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }}"></stats>
        </div>

        </div> -->

        <vue-editor v-if="benchlang === 'de'" id="editor4" v-model="content[4]"></vue-editor>
        <vue-editor v-if="benchlang === 'it'" id="editor4" v-model="contentit[4]"></vue-editor>

      <!-- <h5 v-if="benchlang === 'de'">Bereich Pflege/Betreuung/REHA: Mitarbeiter Altersstufen (Mittelwerte in Prozent zum Stichtag 31.12.)</h5> -->
      <h5 v-if="benchlang === 'de'">{{quests[8].de}}</h5>
      <h5 v-if="benchlang === 'it'">Settore cura/assistenza/riabilitazione: fasce d’età dei collaboratori (media in percentuale)</h5>
      <!-- <h5 v-if="benchlang === 'it'">{{quests[8].it}}</h5> -->

      <div class="grid" style="grid-template-columns: 1fr 1fr">

      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[8].total / klein[8].arr.length), (klein[9].total / klein[9].arr.length), (klein[10].total / klein[10].arr.length), (klein[11].total / klein[11].arr.length), (klein[12].total / klein[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Kleine Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[8].total / mittel[8].arr.length), (mittel[9].total / mittel[9].arr.length), (mittel[10].total / mittel[10].arr.length), (mittel[11].total / mittel[11].arr.length), (mittel[12].total / mittel[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Mittlere Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[8].total / gross[8].arr.length), (gross[9].total / gross[9].arr.length), (gross[10].total / gross[10].arr.length), (gross[11].total / gross[11].arr.length), (gross[12].total / gross[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Grosse Strukturen'
        }}"></pie>


        <div class="grid" v-if="benchlang === 'de'" style="align-content: center justify-content: center">
          <span class="legend yellow">bis 30 Jahre alt</span>
          <span class="legend orange">31 - 40 Jahre alt</span>
          <span class="legend green">41 - 50 Jahre alt</span>
          <span class="legend greendark">51 - 60 Jahre alt</span>
          <span class="legend blue">über 61 Jahre alt</span>
        </div>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[8].total / klein[8].arr.length), (klein[9].total / klein[9].arr.length), (klein[10].total / klein[10].arr.length), (klein[11].total / klein[11].arr.length), (klein[12].total / klein[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture piccole'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[8].total / mittel[8].arr.length), (mittel[9].total / mittel[9].arr.length), (mittel[10].total / mittel[10].arr.length), (mittel[11].total / mittel[11].arr.length), (mittel[12].total / mittel[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture medie'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[8].total / gross[8].arr.length), (gross[9].total / gross[9].arr.length), (gross[10].total / gross[10].arr.length), (gross[11].total / gross[11].arr.length), (gross[12].total / gross[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture grandi'
        }}"></pie>


        <div v-if="benchlang === 'it'" class="grid" style="align-content: center justify-content: center">
          <span class="legend yellow">fino 30 anni</span>
          <span class="legend orange">31 - 40 anni</span>
          <span class="legend green">41 - 50 anni</span>
          <span class="legend greendark">51 - 60 anni</span>
          <span class="legend blue">oltre 61 anni</span>
        </div>

        </div>

        <vue-editor v-if="benchlang === 'de'" id="editor5" v-model="content[5]"></vue-editor>
        <vue-editor v-if="benchlang === 'it'" id="editor5" v-model="contentit[5]"></vue-editor>

      <!-- <h5 v-if="benchlang === 'de'">Nicht-Betreuungsbereich: Mitarbeiter Altersstufen (Mittelwerte in Prozent zum Stichtag 31.12.)</h5> -->
      <h5 v-if="benchlang === 'de'">{{quests[13].de}}</h5>
      <h5 v-if="benchlang === 'it'">Settore non-assistenziale: fasce d’età dei collaboratori (media in percentuale)</h5>
      <!-- <h5 v-if="benchlang === 'it'">{{quests[13].de}}</h5> -->

      <div class="grid" style="grid-template-columns: 1fr 1fr">

      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[13].total / klein[13].arr.length), (klein[14].total / klein[14].arr.length), (klein[15].total / klein[15].arr.length), (klein[16].total / klein[16].arr.length), (klein[17].total / klein[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', align: 'center', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Kleine Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[13].total / mittel[13].arr.length), (mittel[14].total / mittel[14].arr.length), (mittel[15].total / mittel[15].arr.length), (mittel[16].total / mittel[16].arr.length), (mittel[17].total / mittel[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Mittlere Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[13].total / gross[13].arr.length), (gross[14].total / gross[14].arr.length), (gross[15].total / gross[15].arr.length), (gross[16].total / gross[16].arr.length), (gross[17].total / gross[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Grosse Strukturen'
        }}"></pie>


        <div class="grid" v-if="benchlang === 'de'" style="align-content: center justify-content: center">
          <span class="legend yellow">bis 30 Jahre alt</span>
          <span class="legend orange">31 - 40 Jahre alt</span>
          <span class="legend green">41 - 50 Jahre alt</span>
          <span class="legend greendark">51 - 60 Jahre alt</span>
          <span class="legend blue">über 61 Jahre alt</span>
        </div>


        <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[13].total / klein[13].arr.length), (klein[14].total / klein[14].arr.length), (klein[15].total / klein[15].arr.length), (klein[16].total / klein[16].arr.length), (klein[17].total / klein[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', align: 'center', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture piccole'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[13].total / mittel[13].arr.length), (mittel[14].total / mittel[14].arr.length), (mittel[15].total / mittel[15].arr.length), (mittel[16].total / mittel[16].arr.length), (mittel[17].total / mittel[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture medie'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[13].total / gross[13].arr.length), (gross[14].total / gross[14].arr.length), (gross[15].total / gross[15].arr.length), (gross[16].total / gross[16].arr.length), (gross[17].total / gross[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture grandi'
        }}"></pie>


        <div v-if="benchlang === 'it'" class="grid" style="align-content: center justify-content: center">
          <span class="legend yellow">fino 30 anni</span>
          <span class="legend orange">31 - 40 anni</span>
          <span class="legend green">41 - 50 anni</span>
          <span class="legend greendark">51 - 60 anni</span>
          <span class="legend blue">oltre 61 anni</span>
        </div>

        </div>

      <!-- <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['Nicht-Betreuungsbereich: Mitarbeiter bis 30 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 31-40 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 41-50 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 51-60 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          data: [((klein[13].total / klein[13].arr.length)+(mittel[13].total / mittel[13].arr.length)+(gross[13].total / gross[13].arr.length))/3, ((klein[14].total / klein[14].arr.length)+(mittel[14].total / mittel[14].arr.length)+(gross[14].total / gross[14].arr.length))/3, ((klein[15].total / klein[15].arr.length)+(mittel[15].total / mittel[15].arr.length)+(gross[15].total / gross[15].arr.length))/3, ((klein[16].total / klein[16].arr.length)+(mittel[16].total / mittel[16].arr.length)+(gross[16].total / gross[16].arr.length))/3, ((klein[17].total / klein[17].arr.length)+(mittel[17].total / mittel[17].arr.length)+(gross[17].total / gross[17].arr.length))/3]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }}}, title: { display: true, text: 'Nicht-Betreuungsbereich: Mitarbeiter Altersstufen in %'
        }}"></pie>

        <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['Nicht-Betreuungsbereich: Mitarbeiter bis 30 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 31-40 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 41-50 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 51-60 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          data: [((klein[13].total / klein[13].arr.length)+(mittel[13].total / mittel[13].arr.length)+(gross[13].total / gross[13].arr.length))/3, ((klein[14].total / klein[14].arr.length)+(mittel[14].total / mittel[14].arr.length)+(gross[14].total / gross[14].arr.length))/3, ((klein[15].total / klein[15].arr.length)+(mittel[15].total / mittel[15].arr.length)+(gross[15].total / gross[15].arr.length))/3, ((klein[16].total / klein[16].arr.length)+(mittel[16].total / mittel[16].arr.length)+(gross[16].total / gross[16].arr.length))/3, ((klein[17].total / klein[17].arr.length)+(mittel[17].total / mittel[17].arr.length)+(gross[17].total / gross[17].arr.length))/3]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }}}, title: { display: true, text: 'Settore non-assistenziale: fasce d’età dei collaboratori in %'}}"></pie> -->

        <vue-editor v-if="benchlang === 'de'" id="editor6" v-model="content[6]"></vue-editor>
        <vue-editor v-if="benchlang === 'it'" id="editor6" v-model="contentit[6]"></vue-editor>

    <h2 v-if="benchlang === 'de'">5. PROZESSE</h2>
    <h2 v-if="benchlang === 'it'">5. PROCESSI</h2>

    <h5 v-if="benchlang === 'de'">Anteil dokumentierte Schmerzeinschätzungen (Mittelwerte in Prozent)</h5>
    <!-- <h5 v-if="benchlang === 'de'">{{quests[18].de}}</h5> -->
    <h5 v-if="benchlang === 'it'">Quota delle valutazioni del dolore documentate (media in percentuale)</h5>
    <!-- <h5 v-if="benchlang === 'it'">{{quests[18].it}}</h5> -->

    <div class="spacer sm"></div>

    <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[18].totval / klein[18].val.length)+(mittel[18].totval / mittel[18].val.length)+(gross[18].totval / gross[18].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: false, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 400 }}] }, title: { display: false, text: 'Anzahl dokumentierte Schmerzeinschätzung (Mittelwerte)', padding: 40 }}"></stats>

    <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[18].totval / klein[18].val.length)+(mittel[18].totval / mittel[18].val.length)+(gross[18].totval / gross[18].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: false, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 400 }}] }, title: { display: false, text: 'Numero delle valutazioni del dolore documentate (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor7" v-model="content[7]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor7" v-model="contentit[7]"></vue-editor>

      <h5 v-if="benchlang === 'de'">Anteil Bewohner mit Dekubiti (Mittelwerte in Prozent)</h5>
      <h5 v-if="benchlang === 'it'">Quota residenti con decubiti (media in percentuale)</h5>

<!--       <p>{{klein[20].total}} / {{mittel[20].total}} / {{gross[20].total}}</p>
      <p>{{klein[20].arr}} / {{mittel[20].arr}} / {{gross[20].arr}}</p> -->

      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [['Anteil Bewohner mit Dekubiti'],['Anteil Entstehungsort im Heim'],['Anteil Entstehungsort außerhalb des Heimes']],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[19].total / klein[19].arr.length, klein[20].total / klein[20].arr.length, klein[21].total / klein[21].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[19].total / mittel[19].arr.length, mittel[20].total / mittel[20].arr.length, mittel[21].total / mittel[21].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[19].total / gross[19].arr.length, gross[20].total / gross[20].arr.length, gross[21].total / gross[21].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[19].total / klein[19].arr.length)+(mittel[19].total / mittel[19].arr.length)+(gross[19].total / gross[19].arr.length))/3, ((klein[20].total / klein[20].arr.length)+(mittel[20].total / mittel[20].arr.length)+(gross[20].total / gross[20].arr.length))/3, ((klein[21].total / klein[21].arr.length)+(mittel[21].total / mittel[21].arr.length)+(gross[21].total / gross[21].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 10 } }] }, title: { display: false, text: 'Bewohner mit Dekubiti (Mittelwerte)', padding: 40
        }}"></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [['Quota percentuale dei residenti', 'con decubiti (Senso 6)'], ['Quota percentuale dei residenti', 'con decubiti con luogo', 'd’accadimento nella residenza'], ['Quota percentuale dei residenti', 'con decubiti con luogo d’accadimento', 'al di fuori della residenza']],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[19].total / klein[19].arr.length, klein[20].total / klein[20].arr.length, klein[21].total / klein[21].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[19].total / mittel[19].arr.length, mittel[20].total / mittel[20].arr.length, mittel[21].total / mittel[21].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[19].total / gross[19].arr.length, gross[20].total / gross[20].arr.length, gross[21].total / gross[21].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[19].total / klein[19].arr.length)+(mittel[19].total / mittel[19].arr.length)+(gross[19].total / gross[19].arr.length))/3, ((klein[20].total / klein[20].arr.length)+(mittel[20].total / mittel[20].arr.length)+(gross[20].total / gross[20].arr.length))/3, ((klein[21].total / klein[21].arr.length)+(mittel[21].total / mittel[21].arr.length)+(gross[21].total / gross[21].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 10 } }] }, title: { display: false, text: 'Residenti con decubiti (media)', padding: 40
        }}"></stats>

        <vue-editor v-if="benchlang === 'de'" id="editor8" v-model="content[8]"></vue-editor>
        <vue-editor v-if="benchlang === 'it'" id="editor8" v-model="contentit[8]"></vue-editor>

        <h5 v-if="benchlang === 'de'">Anteil Stürze (Mittelwerte in Prozent)</h5>
        <!-- <h5 v-if="benchlang === 'de'">{{quests[22].de}}</h5> -->
        <h5 v-if="benchlang === 'it'">Quota delle cadute (media in percentuale)</h5>
        <div class="spacer sm"></div>

        <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[22].total / klein[22].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[22].total / mittel[22].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[22].total / gross[22].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[22].total / klein[22].arr.length)+(mittel[22].total / mittel[22].arr.length)+(gross[22].total / gross[22].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl Stürze mit Folge (Mittelwerte)', padding: 40 }}"></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[22].total / klein[22].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[22].total / mittel[22].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[22].total / gross[22].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[22].total / klein[22].arr.length)+(mittel[22].total / mittel[22].arr.length)+(gross[22].total / gross[22].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle cadute con conseguenze (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor9" v-model="content[9]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor9" v-model="contentit[9]"></vue-editor>

      <h5 v-if="benchlang === 'de'">Anteil der dokumentierten Sturzprophylaxen (Mittelwerte in Prozent)</h5>
      <!-- <h5 v-if="benchlang === 'de'">Anteil der dokumentierten Sturzprophylaxen (Mittlewerte in Prozent)</h5> -->
      <!-- <h5 v-if="benchlang === 'de'">{{quests[23].de}}</h5> -->
      <h5 v-if="benchlang === 'it'">Quota delle profilassi anticaduta documentate (media in percentuale)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[23].total / klein[23].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[23].total / mittel[23].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[23].total / gross[23].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[23].total / klein[23].arr.length)+(mittel[23].total / mittel[23].arr.length)+(gross[23].total / gross[23].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 9000 }}] }, title: { display: false, text: 'Anzahl Stürze ohne Folge (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[23].total / klein[23].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[23].total / mittel[23].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[23].total / gross[23].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[23].total / klein[23].arr.length)+(mittel[23].total / mittel[23].arr.length)+(gross[23].total / gross[23].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 9000 }}] }, title: { display: false, text: 'Numero delle cadute senza conseguenze (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor10" v-model="content[10]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor10" v-model="contentit[10]"></vue-editor>

      <h5 v-if="benchlang === 'de'">Anteil der Bewohner mit Einsatz freiheitseinschränkender Maßnahmen (Mittelwerte in Prozent)</h5>
      <!-- <h5 v-if="benchlang === 'de'">{{quests[24].de}}</h5> -->
      <h5 v-if="benchlang === 'it'">Quota residenti con degli interventi di contenzione fisica (media in percentuale)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[24].total / klein[24].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[24].total / mittel[24].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[24].total / gross[24].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[24].total / klein[24].arr.length)+(mittel[24].total / mittel[24].arr.length)+(gross[24].total / gross[24].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 40 }}] }, title: { display: false, text: 'Bewohner mit Einsatz freiheitseinschränkender Maßnahmen (Mittelwerte zum Stichtag)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[24].total / klein[24].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[24].total / mittel[24].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[24].total / gross[24].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[24].total / klein[24].arr.length)+(mittel[24].total / mittel[24].arr.length)+(gross[24].total / gross[24].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, suggestedMax: 40 }}] }, title: { display: false, text: 'Residenti con degli interventi di contenzione fisica (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor11" v-model="content[11]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor11" v-model="contentit[11]"></vue-editor>

      <!-- <h5 v-if="benchlang === 'de'">Anzahl quittierter REHA-Leistungen (Mittelwerte)</h5> -->
      <h5 v-if="benchlang === 'de'">{{quests[25].de}}</h5>
      <h5 v-if="benchlang === 'it'">Numero delle prestazioni di riabilitazione eseguite (media)</h5>
      <!-- <h5 v-if="benchlang === 'it'">{{quests[25].it}}</h5> -->
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[25].totval / klein[25].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[25].totval / mittel[25].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[25].totval / gross[25].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[25].totval / klein[25].val.length)+(mittel[25].totval / mittel[25].val.length)+(gross[25].totval / gross[25].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl quittierter REHA-Leistungen (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[25].totval / klein[25].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[25].totval / mittel[25].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[25].totval / gross[25].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[25].totval / klein[25].val.length)+(mittel[25].totval / mittel[25].val.length)+(gross[25].totval / gross[25].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle prestazioni di riabilitazione validate/firmate (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor12" v-model="content[12]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor12" v-model="contentit[12]"></vue-editor>

      <!-- <h5 v-if="benchlang === 'de'">Anzahl quittierter Leistungen der Tagesbetreuung (Mittelwerte)</h5> -->
      <h5 v-if="benchlang === 'de'">{{quests[26].de}}</h5>
      <h5 v-if="benchlang === 'it'">Numero delle prestazioni di assistenza giornaliera/animazione eseguite (media)</h5>
      <!-- <h5 v-if="benchlang === 'it'">{{quests[26].it}}</h5> -->
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[26].totval / klein[26].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[26].totval / mittel[26].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[26].totval / gross[26].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[26].totval / klein[26].val.length)+(mittel[26].totval / mittel[26].val.length)+(gross[26].totval / gross[26].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl quittierter Leistungen der Tagesbetreuung (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[26].totval / klein[26].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[26].totval / mittel[26].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[26].totval / gross[26].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[26].totval / klein[26].val.length)+(mittel[26].totval / mittel[26].val.length)+(gross[26].totval / gross[26].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle prestazioni di assistenza giornaliera/animazione validate/firmate (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor13" v-model="content[13]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor13" v-model="contentit[13]"></vue-editor>

      <!-- <h5 v-if="benchlang === 'de'">Ausgaben für Lebensmittel und Getränke in Euro pro Heimbewohner pro Tag (Mittelwerte)</h5> -->
      <h5 v-if="benchlang === 'de'">{{quests[27].de}}</h5>
      <h5 v-if="benchlang === 'it'">Spese per alimentari e bevande in euro per residente al giorno (media)</h5>
      <!-- <h5 v-if="benchlang === 'it'">{{quests[27].it}}</h5> -->
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[27].toteur / klein[27].eur.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[27].toteur / mittel[27].eur.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[27].toteur / gross[27].eur.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[27].toteur / klein[27].eur.length)+(mittel[27].toteur / mittel[27].eur.length)+(gross[27].toteur / gross[27].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Ausgaben für Lebensmittel und Getränke in € pro Heimbewohner pro Tag (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[27].toteur / klein[27].eur.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[27].toteur / mittel[27].eur.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[27].toteur / gross[27].eur.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[27].toteur / klein[27].eur.length)+(mittel[27].toteur / mittel[27].eur.length)+(gross[27].toteur / gross[27].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Spese per alimentari e bevande in euro per residente al giorno (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor14" v-model="content[14]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor14" v-model="contentit[14]"></vue-editor>

      <!-- <h5 v-if="benchlang === 'de'">Personalkosten Küche für die Zubereitung von Lebensmitteln und den Abwasch in Euro pro Heimbewohner pro Tag (Mittelwerte)</h5> -->
      <h5 v-if="benchlang === 'de'">{{quests[28].de}}</h5>
      <h5 v-if="benchlang === 'it'">Costi in euro per il personale di cucina per la preparazione degli alimenti e per il lavaggio delle stoviglie al giorno per residente (media)</h5>
      <!-- <h5 v-if="benchlang === 'it'">{{quests[28].it}}</h5> -->
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[28].toteur / klein[28].eur.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[28].toteur / mittel[28].eur.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[28].toteur / gross[28].eur.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[28].toteur / klein[28].eur.length)+(mittel[28].toteur / mittel[28].eur.length)+(gross[28].toteur / gross[28].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, stepSize: 5 }}] }, title: { display: false, text: 'Personalkosten Küche für die Zubereitung von Lebensmitteln und den Abwasch in € pro Heimbewohner, pro Tag (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[28].toteur / klein[28].eur.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[28].toteur / mittel[28].eur.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[28].toteur / gross[28].eur.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[28].toteur / klein[28].eur.length)+(mittel[28].toteur / mittel[28].eur.length)+(gross[28].toteur / gross[28].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return null } return value.toFixed(2) }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, stepSize: 5 }}] }, title: { display: false, text: 'Costi per il personale di cucina per la preparazione degli alimenti e per la il lavaggio delle stoviglie per residente in euro, al giorno (media)', padding: 40 }}"></stats>

      <vue-editor v-if="benchlang === 'de'" id="editor15" v-model="content[15]"></vue-editor>
      <vue-editor v-if="benchlang === 'it'" id="editor15" v-model="contentit[15]"></vue-editor>

      <div class="spacer sm"></div>

      <!-- <p>{{klein[18]}}</p>
      <p>{{mittel[18]}} </p>
      <p>{{gross[18]}}</p>
      <p>{{overall[18]}} -</p> -->

    <modal name="edit" width="50%" height="50%" :adaptive="true">
    <a v-on:click="saveContent"><span class="fa fa-edit"></span></a>
     <vue-editor v-model="content1"></vue-editor>
    </modal>

    </div>

  </div>
</div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import Stats from '@/components/Stats'
  import Pie from '@/components/Pie'
  import {Circle4} from 'vue-loading-spinner'
  import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
  import { VueEditor } from 'vue2-editor'
  import _ from 'lodash'
  // import VueCharts from 'vue-chartjs'
  // import { Bar } from 'vue-chartjs'
  // import router from './../router'
  // var host = 'https://bench.node.systems'
  // var host = 'http://localhost'
  var host = process.env.ROOT_HOST
  export default {
    name: 'houses',
    // extends: Bar,
    props: ['cat', 'chartId'],
    data () {
      return {
        loading: false,
        profile: JSON.parse(localStorage.profile),
        tokwt: localStorage.jwt,
        houses: '',
        ratioquests: '',
        datacollection: null,
        content: {},
        contentit: {},
        cont: false,
        options: [{
          value: '2025',
          label: '2025'
        }, {
          value: '2024',
          label: '2024'
        }, {
          value: '2023',
          label: '2023'
        }, {
          value: '2022',
          label: '2022'
        }, {
          value: '2021',
          label: '2021'
        }, {
          value: '2020',
          label: '2020'
        }, {
          value: '2019',
          label: '2019'
        }, {
          value: '2018',
          label: '2018'
        }, {
          value: '2017',
          label: '2017'
        }, {
          value: '2016',
          label: '2016'
        }, {
          value: '2015',
          label: '2015'
        }, {
          value: '2014',
          label: '2014'
        }, {
          value: '2013',
          label: '2013'
        }],
        benchlangs: [{
          value: 'de',
          label: 'Deutsch'
        }, {
          value: 'it',
          label: 'Italienisch'
        }],
        value: '',
        benchlang: '',
        content1: '<h1>content 1</h1>',
        title: [{
          de: 'Verhältnis Brutto- / Nettostunden Mitarbeiter (Mittelwerte)',
          it: 'Ore prestate dai collaboratori: lordo/netto (media)'
        }
        ],
        klein: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          29: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          30: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          31: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          32: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          33: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          34: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          35: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          36: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        mittel: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          29: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          30: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          31: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          32: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          33: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          34: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          35: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          36: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        gross: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          29: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          30: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          31: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          32: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          33: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          34: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          35: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          36: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        overall: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          29: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          30: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          31: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          32: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          33: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          34: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          35: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          36: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        quests: {
          1: {de: '', it: ''},
          2: {de: '', it: ''},
          3: {de: '', it: ''},
          4: {de: '', it: ''},
          5: {de: '', it: ''},
          6: {de: '', it: ''},
          7: {de: '', it: ''},
          8: {de: '', it: ''},
          9: {de: '', it: ''},
          10: {de: '', it: ''},
          11: {de: '', it: ''},
          12: {de: '', it: ''},
          13: {de: '', it: ''},
          14: {de: '', it: ''},
          15: {de: '', it: ''},
          16: {de: '', it: ''},
          17: {de: '', it: ''},
          18: {de: '', it: ''},
          19: {de: '', it: ''},
          20: {de: '', it: ''},
          21: {de: '', it: ''},
          22: {de: '', it: ''},
          23: {de: '', it: ''},
          24: {de: '', it: ''},
          25: {de: '', it: ''},
          26: {de: '', it: ''},
          27: {de: '', it: ''},
          28: {de: '', it: ''},
          29: {de: '', it: ''},
          30: {de: '', it: ''},
          31: {de: '', it: ''},
          32: {de: '', it: ''},
          33: {de: '', it: ''},
          34: {de: '', it: ''},
          35: {de: '', it: ''},
          36: {de: '', it: ''}
        }
      }
    },
    components: {
      Circle4,
      Navbar,
      // Bar,
      Stats,
      Pie,
      ChartJsPluginDataLabels,
      VueEditor
    },
    methods: {
      saveWord () {
        this.loading = true
        this.$http
          .post(host + ':44534/save/word', {quests: this.quests, content: this.content, contentit: this.contentit, klein: this.klein, mittel: this.mittel, gross: this.gross, overall: this.overall, year: this.value, lang: this.benchlang},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
            ).then((data) => {
              // this.ombrelli = data.body.ombrells
              console.log(data)
              // this.houses = data.body.houses
              // let blob = new Blob(data.data, { type: 'application/pdf' }),
              //   url = window.URL.createObjectURL(blob)
              window.open(host + ':44534/benchmarks/download/' + data.data.url)
              this.loading = false
              this.$notify({
                group: 'foo',
                title: 'Bench exported successfully',
                type: 'success',
                duration: 500
              })
            }, (error) => {
              console.log(error)
              // localStorage.setItem('bench_de', JSON.stringify(this.content), 'bench_it', JSON.stringify(this.contentit), 'year', this.value, 'lang', this.benchlang)
              this.$notify({
                group: 'foo',
                title: 'Fehler beim Speichern',
                type: 'error',
                duration: 500
              })
            })
      },
      edit: function (text) {
        console.log(text)
        this.content = text
        console.log(this.content)
        this.$modal.show('edit')
      },
      getoverall: function () {
        // this.overall.forEach((house, index) => {
        //   // console.log(house)
        // })
      },
      getHouses: function () {
        this.loading = true
        this.$http
          .get(host + ':44534/api/houses',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data.body)
            this.houses = data.body.houses
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      },
      getContent: function (year) {
        this.loading = true
        this.$http
          .get(host + ':44534/api/benchmark/' + this.value,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            this.content = {}
            console.log(data.body.benchmarks)
            console.log(this.benchlang)
          // if (this.benchlang === 'de') {
            if (data.body.benchmarks.content === null || data.body.benchmarks.content === undefined) {
              this.content = {}
            } else {
              this.content = data.body.benchmarks.content
            }
          // } else {
            if (data.body.benchmarks.contentit === null || data.body.benchmarks.contentit === undefined) {
              this.contentit = {}
            } else {
              this.contentit = data.body.benchmarks.contentit
            }
          // }
            this.loading = false
            this.cont = true
          }, (error) => {
            console.log(error)
          })
      },
      saveContent: function () {
        console.log(this.content)
        console.log(this.contentit)
        this.loading = true
        // if (this.benchlang === 'de') {
        this.$http
        .post(host + ':44534/api/benchmark/', {year: this.value, content: this.content, contentit: this.contentit},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            // this.houses = data.body.houses
            this.loading = false
            this.$notify({
              group: 'foo',
              title: 'Bench saved successfully',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
            localStorage.setItem('bench_de', JSON.stringify(this.content), 'bench_it', JSON.stringify(this.contentit), 'year', this.value, 'lang', this.benchlang)
            this.$notify({
              group: 'foo',
              title: 'Fehler beim Speichern',
              type: 'error',
              duration: 500
            })
          })
        // } else {
        //   console.log(this.benchlang)
        //   this.$http
        //     .post(host + ':44534/api/benchmark/', {year: this.value, contentit: this.contentit},
        //     {
        //       headers: {
        //         'Authorization': 'Bearer ' + localStorage.jwt
        //       }
        //     }
        //     ).then((data) => {
        //       // this.ombrelli = data.body.ombrells
        //       console.log(data.body)
        //       // this.houses = data.body.houses
        //       this.loading = false
        //       this.$notify({
        //         group: 'foo',
        //         title: 'Bench saved successfully',
        //         type: 'success',
        //         duration: 500
        //       })
        //     }, (error) => {
        //       console.log(error)
        //       this.$notify({
        //         group: 'foo',
        //         title: 'Fehler beim Speichern',
        //         type: 'error',
        //         duration: 500
        //       })
        //       localStorage.setItem('bench_de', JSON.stringify(this.content), 'bench_it', JSON.stringify(this.contentit), 'year', this.value, 'lang', this.benchlang)
        //     })
        // }
      },
      getBench: function (house) {
        this.loading = true
        this.$http
          .get(host + ':44534/api/bench/' + house,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data.body)
            this.ratioquests = data.body.ratioquests
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      },
      getBenchVersion: function (version) {
        this.loading = true
        // this.$http
        //   .get(host + ':44534/api/bench/' + version,
        //   {
        //     headers: {
        //       'Authorization': 'Bearer ' + localStorage.jwt
        //     }
        //   }
        //   ).then((data) => {
        //     // this.ombrelli = data.body.ombrells
        //     // console.log(data.body)
        //     this.ratioquests = data.body.ratioquests
        //     this.loading = false
        //   }, (error) => {
        //     console.log(error)
        //   })
      },
      getBenchAll: function (house) {
        this.loading = true
        this.getBench2('klein')
        this.getBench2('mittel')
        this.getBench2('gross')
        this.getContent()
      },
      getBench2: function (size) {
        this.loading = true
        // console.log(this.value)
        // this.ratioquests = ''
        this.$http
          .get(host + ':44534/api/houses/' + size,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data.body.houses)
            data.body.houses.forEach((house, index) => {
              // console.log(house)
              this.$http
                .get(host + ':44534/api/bench/' + house._id + '/' + this.value,
                {
                  headers: {
                    'Authorization': 'Bearer ' + localStorage.jwt
                  }
                }
                ).then((data) => {
                  // this.ombrelli = data.body.ombrells
                  // console.log(data.body.ratioquests)
                  data.body.ratioquests.forEach((house, index) => {
                    this.quests[house.nr].de = house.quest
                    this.quests[house.nr].it = house.questit
                    // if (house.cat === 2 && house.ratioperc && house.ratioperc !== null) {
                    //   this.cat2.push(house.ratioperc)
                    //   this.cat2total += house.ratioperc
                    //   console.log(house.ratioperc)
                    // }
                    // if (house.cat === 3 && house.ratioperc && house.ratioperc !== null) {
                    //   this.cat3.push(house.ratioperc)
                    //   this.cat3total += house.ratioperc
                    //   console.log(house.ratioperc)
                    // }
                    // console.log(house.ratioperc)
                    // if (house.nr === 19) { console.log(house.ratioval) }
                    if (house.ratioperc !== 'undefined' && typeof (house.ratioperc) === 'number') {
                      this.overall[house.nr].arr.push(house.ratioperc)
                      this.overall[house.nr].total += house.ratioperc
                      // console.log(house.cat + '-' + this.overall[house.cat].total)
                      // console.log(house.ratioperc)
                    }
                    if (size === 'klein') {
                      if (house.ratioperc !== undefined && typeof (house.ratioperc) === 'number') {
                        this.klein[house.nr].arr.push(house.ratioperc)
                        this.klein[house.nr].total += house.ratioperc
                        // console.log(house.ratioperc)
                      }
                      if (house.ratioval !== undefined && Number.isInteger(house.ratioval)) {
                        this.klein[house.nr].val.push(house.ratioval)
                        this.klein[house.nr].totval += house.ratioval
                        // console.log(house.ratioperc)
                        // if (house.nr === 19) { console.log(house.ratioval) }
                      }
                      if (house.ratioeur !== 'undefined' && typeof (house.ratioeur) === 'number') {
                        // console.log(house.ratioeur)
                        this.klein[house.nr].eur.push(house.ratioeur)
                        this.klein[house.nr].toteur += house.ratioeur
                        // console.log(house.ratioperc)
                      }
                    }
                    if (size === 'mittel') {
                      if (house.ratioperc !== undefined && typeof (house.ratioperc) === 'number') {
                        this.mittel[house.nr].arr.push(house.ratioperc)
                        this.mittel[house.nr].total += house.ratioperc
                        // console.log(house.ratioperc)
                      }
                      if (house.ratioval !== undefined && Number.isInteger(house.ratioval)) {
                        this.mittel[house.nr].val.push(house.ratioval)
                        this.mittel[house.nr].totval += house.ratioval
                        // console.log(house.ratioperc)
                        // if (house.nr === 19) { console.log(house.ratioval) }
                      }
                      if (house.ratioeur !== 'undefined' && typeof (house.ratioeur) === 'number') {
                        // console.log(house.ratioeur)
                        this.mittel[house.nr].eur.push(house.ratioeur)
                        this.mittel[house.nr].toteur += house.ratioeur
                        // console.log(house.ratioperc)
                      }
                    }
                    if (size === 'gross') {
                      if (house.ratioperc !== undefined && typeof (house.ratioperc) === 'number') {
                        this.gross[house.nr].arr.push(house.ratioperc)
                        this.gross[house.nr].total += house.ratioperc
                        // console.log(house.ratioperc)
                      }
                      if (house.ratioval !== undefined && Number.isInteger(house.ratioval)) {
                        this.gross[house.nr].val.push(house.ratioval)
                        this.gross[house.nr].totval += house.ratioval
                        // console.log(house.ratioperc)
                        // if (house.nr === 19) { console.log(house.ratioval) }
                      }
                      if (house.ratioeur !== 'undefined' && typeof (house.ratioeur) === 'number') {
                        // console.log(house.ratioeur)
                        this.gross[house.nr].eur.push(house.ratioeur)
                        this.gross[house.nr].toteur += house.ratioeur
                        // console.log(house.ratioperc)
                      }
                    }
                  })
                  this.loading = false
                }, (error) => {
                  console.log(error)
                })
            })
          }, (error) => {
            console.log(error)
          })
      },
      savetocsv () {
        /* eslint-disable */
        // var ratios = []
        this.loading = true
        this.$http
          .get(host + ':44534/api/ratios/year/' + this.value || '2021',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // console.log()
            // const finalquests = []
            const finalquests = [{
              '': ''
            }]
            const finalklein = [{
              '': 'Kleine Heime'
            }]
            const finalmittel = [{
              '': 'Mittlere Heime'
            }]
            const finalgross = [{
              '': 'Grosse Heime'
            }]
            // const ratioquests = _.chain(data.data.ratioquests).groupBy('nr').map((value, key) => {
            //   return {
            //     ['Kennzahl ' + key]: value
            //   }
            // }).value()
            const ratioquests = _.chain(data.data.ratioquests).groupBy('nr').value()
            // console.log(ratioquests)

             _.chain(ratioquests).forEach((value, index) => {
              if (value[0].ratiovalues[0].euro) {
                finalklein.push({
                  ['Kennzahl ' + index]: parseFloat((this.klein[index].toteur / this.klein[index].eur.length).toFixed(2))
                })
                // finalklein['Kennzahl ' + index] = parseFloat((this.klein[index].toteur / this.klein[index].eur.length).toFixed(2))
              }
              if (value[0].ratiovalues[0].number) {
                // console.log(index, value)
                finalklein.push({
                  ['Kennzahl ' + index]: parseFloat((this.klein[index].totval / this.klein[index].val.length).toFixed(2))
                })
                // finalklein['Kennzahl ' + index] = parseFloat((this.klein[index].totval / this.klein[index].val.length).toFixed(2))
              }
              if (value[0].ratiovalues[0].perc) {
                finalklein.push({
                  ['Kennzahl ' + index + ' in %']: parseFloat((this.klein[index].total / this.klein[index].arr.length).toFixed(2))
                })
                // finalklein['Kennzahl ' + index] = parseFloat((this.klein[index].total / this.klein[index].arr.length).toFixed(2))
              }
            }).value()

             _.chain(ratioquests).forEach((value, index) => {
              if (value[0].ratiovalues[0].euro) {
                finalmittel.push({
                  ['Kennzahl ' + index]: parseFloat((this.mittel[index].toteur / this.mittel[index].eur.length).toFixed(2))
                })
                // finalmittel['Kennzahl ' + index] = parseFloat((this.mittel[index].toteur / this.mittel[index].eur.length).toFixed(2))
              }
              if (value[0].ratiovalues[0].number) {
                finalmittel.push({
                  ['Kennzahl ' + index]: parseFloat((this.mittel[index].totval / this.mittel[index].val.length).toFixed(2))
                })
                // finalmittel['Kennzahl ' + index] = parseFloat((this.mittel[index].totval / this.mittel[index].val.length).toFixed(2))
              }
              if (value[0].ratiovalues[0].perc) {
                finalmittel.push({
                  ['Kennzahl ' + index + ' in %']: parseFloat((this.mittel[index].total / this.mittel[index].arr.length).toFixed(2))
                })
                // finalmittel['Kennzahl ' + index] = parseFloat((this.mittel[index].total / this.mittel[index].arr.length).toFixed(2))
              }
            }).value()

             _.chain(ratioquests).forEach((value, index) => {
              if (value[0].ratiovalues[0].euro) {
                finalgross.push({
                  ['Kennzahl ' + index]: parseFloat((this.gross[index].toteur / this.gross[index].eur.length).toFixed(2))
                })
                // finalgross['Kennzahl ' + index] = parseFloat((this.mittel[index].toteur / this.mittel[index].eur.length).toFixed(2))
              }
              if (value[0].ratiovalues[0].number) {
                finalgross.push({
                  ['Kennzahl ' + index]: parseFloat((this.gross[index].totval / this.gross[index].val.length).toFixed(2))
                })
                // finalgross['Kennzahl ' + index] = parseFloat((this.mittel[index].totval / this.mittel[index].val.length).toFixed(2))
              }
              if (value[0].ratiovalues[0].perc) {
                finalgross.push({
                  ['Kennzahl ' + index + ' in %']: parseFloat((this.gross[index].total / this.gross[index].arr.length).toFixed(2))
                })
                // finalgross['Kennzahl ' + index] = parseFloat((this.mittel[index].total / this.mittel[index].arr.length).toFixed(2))
              }
            }).value()

            _.chain(ratioquests).forEach((value, index) => {
              if (value[0].ratiovalues[0].euro) {
                finalquests.push({
                  ['Kennzahl ' + index]: value[0].quest
                })
                // finalquests['Kennzahl ' + index] = value[0].quest
              }
              if (value[0].ratiovalues[0].number) {
                finalquests.push({
                  ['Kennzahl ' + index]: value[0].quest
                })
                // finalquests['Kennzahl ' + index] = value[0].quest
              }
              if (value[0].ratiovalues[0].perc) {
                finalquests.push({
                  ['Kennzahl ' + index + ' in %']: value[0].quest
                })
                // finalquests['Kennzahl ' + index] = value[0].quest
              }
            }).value()
            console.log(finalquests)
            console.log(finalklein)
            console.log(finalmittel)
            console.log(_.reduce(finalgross, function(memo, current) { return _.assign(memo, current) }, {}))
            var final = [Object.assign({}, ...finalquests), Object.assign({}, ...finalklein), Object.assign({}, ...finalmittel), Object.assign({}, ...finalgross)]
            console.log(final)
            // return final

            this.loading = true
            this.$http
            .post(host + ':44534/save/csv', {benchmarkdata: final},
            {
              headers: {
                'Authorization': 'Bearer ' + localStorage.jwt
              }
            }
              ).then((data) => {
                // this.ombrelli = data.body.ombrells
                console.log(data)
                // this.houses = data.body.houses
                // let blob = new Blob(data.data, { type: 'application/pdf' }),
                //   url = window.URL.createObjectURL(blob)
                window.open(host + ':44534/benchmarks/download/' + data.data.url)
                this.loading = false
                this.$notify({
                  group: 'foo',
                  title: 'Bench exported successfully',
                  type: 'success',
                  duration: 500
                })
              }, (error) => {
                console.log(error)
                this.loading = false
                // localStorage.setItem('bench_de', JSON.stringify(this.content), 'bench_it', JSON.stringify(this.contentit), 'year', this.value, 'lang', this.benchlang)
                this.$notify({
                  group: 'foo',
                  title: 'Fehler beim Speichern',
                  type: 'error',
                  duration: 500
                })
              })

            // const finaldata = JSON.stringify(final)
            // const blob = new Blob([finaldata], {type: 'text/plain'})
            // const e = document.createEvent('MouseEvents'),
            // a = document.createElement('a')
            // a.download = 'final.json'
            // a.href = window.URL.createObjectURL(blob)
            // a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
            // e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            // a.dispatchEvent(e)

            // var final = _.concat(finalquests, finalklein, finalmittel, finalgross)
            // console.log(final)
            // {
            //   '': '',
            //   'Kennzahl 1': 'Verhältnis Brutto-/Nettostunden',
            //   'Kennzahl 2': 'Auslastung Daueraufnahme',
            //   'Kennzahl 3': 'Auslastung Kurzzeit',
            // },
            // ratios = _.chain(data.data.ratioquests).groupBy('').value()
            // console.log(ratios)
              this.loading = false
          }, (error) => {
            console.log(error)
            this.loading = false
          })
        // return ratios
      }
      // saveFile () {
      //   /* eslint-disable */
      //   // console.log(_.forEach(this.bucketdata, function(o) {
      //   //   console.log('o ', o)
      //   //   return _.omit(o, ['_id'])
      //   // }))
      //   // var downloaddata = _.forEach(this.bucketdata, function(o) {
      //   //   console.log('o ', o)
      //   //   return _.omit(o, ['_id'])
      //   // })
      //   // console.log(downloaddata)
      //   // const data = JSON.stringify(this.bucketdata)
      //   const data = JSON.stringify(this.ratios)
      //   const blob = new Blob([data], {type: 'text/plain'})
      //   const e = document.createEvent('MouseEvents'),
      //   a = document.createElement('a')
      //   a.download = 'final.json'
      //   a.href = window.URL.createObjectURL(blob)
      //   a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      //   e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      //   a.dispatchEvent(e)
      // }
    },
    beforeMount () {
      // this.getBench2('klein')
      // this.getBench2('mittel')
      // this.getBench2('gross')
      // this.getHouses()
      // this.getContent('2017')
    },
    computed: {
      /* eslint-disable */
      // ratios () {
      //   var ratios = []
      //   this.$http
      //     .get(host + ':44534/api/ratios/year/' + this.value || '2021',
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     }
      //     ).then((data) => {
      //       // console.log()
      //       // const finalquests = []
      //       const finalquests = [{
      //         '': ''
      //       }]
      //       const finalklein = [{
      //         '': 'Kleine Heime'
      //       }]
      //       const finalmittel = [{
      //         '': 'Mittlere Heime'
      //       }]
      //       const finalgross = [{
      //         '': 'Grosse Heime'
      //       }]
      //       // const ratioquests = _.chain(data.data.ratioquests).groupBy('nr').map((value, key) => {
      //       //   return {
      //       //     ['Kennzahl ' + key]: value
      //       //   }
      //       // }).value()
      //       const ratioquests = _.chain(data.data.ratioquests).groupBy('nr').value()
      //       // console.log(ratioquests)

      //        _.chain(ratioquests).forEach((value, index) => {
      //         if (value[0].ratiovalues[0].euro) {
      //           finalklein.push({
      //             ['Kennzahl ' + index]: parseFloat((this.klein[index].toteur / this.klein[index].eur.length).toFixed(2))
      //           })
      //           // finalklein['Kennzahl ' + index] = parseFloat((this.klein[index].toteur / this.klein[index].eur.length).toFixed(2))
      //         }
      //         if (value[0].ratiovalues[0].number) {
      //           finalklein.push({
      //             ['Kennzahl ' + index]: parseFloat((this.klein[index].totval / this.klein[index].val.length).toFixed(2))
      //           })
      //           // finalklein['Kennzahl ' + index] = parseFloat((this.klein[index].totval / this.klein[index].val.length).toFixed(2))
      //         }
      //         if (value[0].ratiovalues[0].perc) {
      //           finalklein.push({
      //             ['Kennzahl ' + index + ' in %']: parseFloat((this.klein[index].total / this.klein[index].arr.length).toFixed(2))
      //           })
      //           // finalklein['Kennzahl ' + index] = parseFloat((this.klein[index].total / this.klein[index].arr.length).toFixed(2))
      //         }
      //       }).value()

      //        _.chain(ratioquests).forEach((value, index) => {
      //         if (value[0].ratiovalues[0].euro) {
      //           finalmittel.push({
      //             ['Kennzahl ' + index]: parseFloat((this.mittel[index].toteur / this.mittel[index].eur.length).toFixed(2))
      //           })
      //           // finalmittel['Kennzahl ' + index] = parseFloat((this.mittel[index].toteur / this.mittel[index].eur.length).toFixed(2))
      //         }
      //         if (value[0].ratiovalues[0].number) {
      //           finalmittel.push({
      //             ['Kennzahl ' + index]: parseFloat((this.mittel[index].totval / this.mittel[index].val.length).toFixed(2))
      //           })
      //           // finalmittel['Kennzahl ' + index] = parseFloat((this.mittel[index].totval / this.mittel[index].val.length).toFixed(2))
      //         }
      //         if (value[0].ratiovalues[0].perc) {
      //           finalmittel.push({
      //             ['Kennzahl ' + index + ' in %']: parseFloat((this.mittel[index].total / this.mittel[index].arr.length).toFixed(2))
      //           })
      //           // finalmittel['Kennzahl ' + index] = parseFloat((this.mittel[index].total / this.mittel[index].arr.length).toFixed(2))
      //         }
      //       }).value()

      //        _.chain(ratioquests).forEach((value, index) => {
      //         if (value[0].ratiovalues[0].euro) {
      //           finalgross.push({
      //             ['Kennzahl ' + index]: parseFloat((this.gross[index].toteur / this.gross[index].eur.length).toFixed(2))
      //           })
      //           // finalgross['Kennzahl ' + index] = parseFloat((this.mittel[index].toteur / this.mittel[index].eur.length).toFixed(2))
      //         }
      //         if (value[0].ratiovalues[0].number) {
      //           finalgross.push({
      //             ['Kennzahl ' + index]: parseFloat((this.gross[index].totval / this.gross[index].val.length).toFixed(2))
      //           })
      //           // finalgross['Kennzahl ' + index] = parseFloat((this.mittel[index].totval / this.mittel[index].val.length).toFixed(2))
      //         }
      //         if (value[0].ratiovalues[0].perc) {
      //           finalgross.push({
      //             ['Kennzahl ' + index + ' in %']: parseFloat((this.gross[index].total / this.gross[index].arr.length).toFixed(2))
      //           })
      //           // finalgross['Kennzahl ' + index] = parseFloat((this.mittel[index].total / this.mittel[index].arr.length).toFixed(2))
      //         }
      //       }).value()

      //       _.chain(ratioquests).forEach((value, index) => {
      //         if (value[0].ratiovalues[0].euro) {
      //           finalquests.push({
      //             ['Kennzahl ' + index]: value[0].quest
      //           })
      //           // finalquests['Kennzahl ' + index] = value[0].quest
      //         }
      //         if (value[0].ratiovalues[0].number) {
      //           finalquests.push({
      //             ['Kennzahl ' + index]: value[0].quest
      //           })
      //           // finalquests['Kennzahl ' + index] = value[0].quest
      //         }
      //         if (value[0].ratiovalues[0].perc) {
      //           finalquests.push({
      //             ['Kennzahl ' + index + ' in %']: value[0].quest
      //           })
      //           // finalquests['Kennzahl ' + index] = value[0].quest
      //         }
      //       }).value()
      //       console.log(finalquests)
      //       console.log(finalklein)
      //       console.log(finalmittel)
      //       console.log(_.reduce(finalgross, function(memo, current) { return _.assign(memo, current) }, {}))
      //       var final = [Object.assign({}, ...finalquests), Object.assign({}, ...finalklein), Object.assign({}, ...finalmittel), Object.assign({}, ...finalgross)]
      //       console.log(final)
      //       // return final

      //       const finaldata = JSON.stringify(final)
      //       const blob = new Blob([finaldata], {type: 'text/plain'})
      //       const e = document.createEvent('MouseEvents'),
      //       a = document.createElement('a')
      //       a.download = 'final.json'
      //       a.href = window.URL.createObjectURL(blob)
      //       a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      //       e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      //       a.dispatchEvent(e)

      //       // var final = _.concat(finalquests, finalklein, finalmittel, finalgross)
      //       // console.log(final)
      //       // {
      //       //   '': '',
      //       //   'Kennzahl 1': 'Verhältnis Brutto-/Nettostunden',
      //       //   'Kennzahl 2': 'Auslastung Daueraufnahme',
      //       //   'Kennzahl 3': 'Auslastung Kurzzeit',
      //       // },
      //       // ratios = _.chain(data.data.ratioquests).groupBy('').value()
      //       // console.log(ratios)
      //     }, (error) => {
      //       console.log(error)
      //     })
      //   return ratios
      // }
    },
    mounted () {
    }
  }
</script>

<style>
  a {
    cursor: pointer
  }
</style>




// WEBPACK FOOTER //
// src/components/Houses.vue